export default "__VITE_ASSET__yajCWaeq__"